// Core React imports and initialization
import React from 'react';
import { createRoot } from 'react-dom/client'
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css'
import './styles/tokens.css' // bridge: define as CSS vars que as Views do Claude Design consomem
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { initializeErrorLogging } from './config/errorLoggingInit';

// Initialize error logging
initializeErrorLogging();

console.log('[MAIN] ✓ App initialized - Mode:', import.meta.env.MODE);

try {
  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement);
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
} catch (error) {
  console.error('[MAIN] ERRO AO RENDERIZAR:', error);
  console.error('[MAIN] Stack:', error.stack);
  document.body.innerHTML = `<div style="color:red;padding:20px;font-family:monospace;">
    <h1>ERRO DE RENDERIZAÇÃO</h1>
    <pre>${error.message}\n\n${error.stack}</pre>
  </div>`;
}
